import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { DiaryEntryForm } from '../components/diary';
import api from '../api';
import { getAuthenticatedAccountId } from '../selectors/auth';
import { getSelectedProfile } from '../selectors/profiles';

import { v4 as uuidv4 } from 'uuid';

class DiaryEntryCreateContainer extends Component {
  componentDidMount() {
    this.props.entriesCreateReset({});
  }

  render() {
    const {
      accountId,
      profile,
      entriesCreate,
      entriesCreateReset,
      onDiaryEntryCreated
    } = this.props;

    const handleSubmit = values => {
      entriesCreateReset({});
      const cleanedUpValues = _.pick(values, ['content', 'feeling', 'hidden']);
      entriesCreate(
        { accountId, profileId: profile.id },
        {
          body: JSON.stringify({
            id: uuidv4(),
            ...cleanedUpValues
          })
        }
      );
      onDiaryEntryCreated();
    };

    return <DiaryEntryForm isNew onSubmit={handleSubmit} />;
  }
}

DiaryEntryCreateContainer.propTypes = {
  accountId: PropTypes.string.isRequired,
  profile: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }).isRequired,
  entriesCreate: PropTypes.func.isRequired,
  entriesCreateReset: PropTypes.func.isRequired,
  onDiaryEntryCreated: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    accountId: getAuthenticatedAccountId(state),
    profile: getSelectedProfile(state),
    ...ownProps
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      entriesCreate: api.actions.entriesCreate,
      entriesCreateReset: api.actions.entriesCreate.reset
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(
  DiaryEntryCreateContainer
);



// WEBPACK FOOTER //
// ./src/containers/DiaryEntryCreateContainer.js